import * as React from 'react';
import {useEffect, useState} from "react";
import {currentSession} from "../../Auth";
import {APP_ACTION_ITEMS, APP_LOGIN_PATH} from "../../types";
import {useHistory} from "react-router-dom";


const PublicMainContainer: React.FunctionComponent = () => {
    const [doLoginRedirect, setDoLoginRedirect] = useState(false);
    const [doActionItemRedirect, setDoActionItemRedirect] = useState(false);
    const history = useHistory();
    useEffect(() => {
        currentSession().then(session => {
            setDoActionItemRedirect(true);
        }).catch(e => setDoLoginRedirect(true))
    }, [history]);

    useEffect(() => {
        if (doActionItemRedirect) {
            history.push({
                pathname: APP_ACTION_ITEMS
            });
        }
    }, [doActionItemRedirect, history]);

    useEffect(() => {
        if (doLoginRedirect) {
            history.push({
                pathname: APP_LOGIN_PATH
            });
        }
    }, [doLoginRedirect, history]);
    return (<>

    </>);
};

export default PublicMainContainer;